import { render, staticRenderFns } from "./custom-modal.vue?vue&type=template&id=18179b2a&scoped=true"
import script from "./custom-modal.vue?vue&type=script&lang=ts"
export * from "./custom-modal.vue?vue&type=script&lang=ts"
import style0 from "./custom-modal.vue?vue&type=style&index=0&id=18179b2a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18179b2a",
  null
  
)

export default component.exports